import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';
import chevronUpWhite from '~/icons/chevron-up-white.svg';


export default ({ blok }) => {
  const swiperInst = React.useRef(null);

  return (
    <section className="py-20 my-20 overflow-hidden text-white bg-black md:my-28 md:py-28">
      <header className="container flex flex-col items-start justify-between mb-16 md:flex-row md:items-end">
        {blok.textCard.length > 0 && <TextCard blok={blok.textCard[0]} />}
        <div className="flex justify-center w-full mt-4 md:w-auto md:justify-start md:mt-0">
          <button className="p-1 outline-none" onClick={() => swiperInst.current.swiper.slidePrev()}>
            <div className="flex items-center justify-center w-12 h-12 transition-colors bg-transparent border-2 border-white rounded-full hover:border-blue hover:bg-blue">
              <img src={chevronUpWhite} className="-ml-1 transform -rotate-90" alt="" />
            </div>
          </button>
          <button className="p-1 outline-none" onClick={() => swiperInst.current.swiper.slideNext()}>
            <div className="flex items-center justify-center w-12 h-12 transition-colors bg-transparent border-2 border-white rounded-full hover:border-blue hover:bg-blue">
              <img src={chevronUpWhite} className="ml-1 transform rotate-90" alt="" />
            </div>
          </button>
        </div>
      </header>

      {blok.slides?.length > 0 && (
        <Swiper ref={swiperInst} loop={true} slidesPerView={'auto'} spaceBetween={20} lazy={true}>
          {blok?.slides?.map((slide) => (
            <SwiperSlide key={slide.id} className="w-full sm:max-w-lg">
              {({ isActive }) => (
                <div
                  className={`${
                    !isActive && 'opacity-80'
                  } transition-opacity duration-150 cursor-pointer group relative`}
                >
                  <Image blok={slide} imageClassName="aspect-w-4 aspect-h-3" />
                </div>
              )}
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </section>
  );
};
